// 引入 moment 和 lunar-calendar 库
const moment = require('moment');
const LunarCalendar = require('lunar-calendar');

export function getFullMonthDates(monthStr) {
  // 将字符串解析为 moment 对象
  const startOfMonth = moment(monthStr, 'YYYY-MM').startOf('month');
  const endOfMonth = moment(monthStr, 'YYYY-MM').endOf('month');

  // 获取当月所有日期
  const monthDates = [];
  for (let m = startOfMonth.clone(); m.isBefore(endOfMonth) || m.isSame(endOfMonth); m.add(1, 'days')) {
    const lunar = LunarCalendar.solarToLunar(m.year(), m.month() + 1, m.date()); // 获取农历信息
    const lunarDayName = lunar.lunarDay === 1 ? lunar.lunarMonthName : lunar.lunarDayName;
    monthDates.push({
      date: moment(m.toDate()).format('YYYY-MM-DD'),
      day: m.date(),
      lunarDayName,
      disabled: moment().diff(m, 'days') > 0,
      weekDay: m.day(),
      moreStepVisible: false,
      recruitDetailVisible: false,
    });
  }

  // 获取当月1号是周几 (0为周日，6为周六)
  const firstDayWeek = startOfMonth.day();

  // 计算需要补齐的前面日期
  const prevDaysCount = firstDayWeek === 0 ? 6 : firstDayWeek - 1;
  const prevDates = [];
  for (let i = prevDaysCount; i > 0; i--) {
    const m = startOfMonth.clone().subtract(i, 'days');
    const lunar = LunarCalendar.solarToLunar(m.year(), m.month() + 1, m.date()); // 获取农历信息
    const lunarDayName = lunar.lunarDay === 1 ? lunar.lunarMonthName : lunar.lunarDayName;
    prevDates.push({
      date: moment(m.toDate()).format('YYYY-MM-DD'),
      day: m.date(),
      lunarDayName,
      disabled: true,
      weekDay: m.day(),
      moreStepVisible: false,
      recruitDetailVisible: false,
    });
  }

  // 获取最后一天是周几
  const lastDayWeek = endOfMonth.day();

  // 计算需要补齐的后面日期
  const nextDaysCount = lastDayWeek === 0 ? 0 : 7 - lastDayWeek;
  const nextDates = [];
  for (let i = 1; i <= nextDaysCount; i++) {
    const m = endOfMonth.clone().add(i, 'days');
    const lunar = LunarCalendar.solarToLunar(m.year(), m.month() + 1, m.date()); // 获取农历信息
    const lunarDayName = lunar.lunarDay === 1 ? lunar.lunarMonthName : lunar.lunarDayName;
    nextDates.push({
      date: moment(m.toDate()).format('YYYY-MM-DD'),
      day: m.date(),
      lunarDayName,
      disabled: true,
      weekDay: m.day(),
      moreStepVisible: false,
      recruitDetailVisible: false,
    });
  }

  // 返回完整日期数组
  return [...prevDates, ...monthDates, ...nextDates];
}

export function getYearMonths(year) {
  const currentYear = moment().year(); // 当前年份
  const currentMonth = moment().month() + 1; // 当前月份 (1-12)

  return Array.from({ length: 12 }, (_, index) => {
    const month = index + 1; // 月份 (1-12)
    return {
      label: `${month}月`, // 形如 "1月"
      value: month < 10 ? `0${month}` : `${month}`,
      isCurrentMonth: year === currentYear && month === currentMonth, // 是否为当前月
    };
  });
}
